import { z } from "zod";
import { DateTypeSchema, TemplateTypeSchema } from "./core.schema";
import { BaseFirestoreWStatusTagsSchema } from "./firestore.schema";
import { LetterHeadSchema, PublicLetterHeadSchema } from "./letterHead.schema";
import {
  AgendaModuleSchema,
  PublicAgendaModuleSchema,
} from "./agendaModule.schema";

// Schemas

export const AgendaSchema = BaseFirestoreWStatusTagsSchema.merge(
  TemplateTypeSchema
).extend({
  name: z.string(),
  description: z.string(),
  downloadUrl: z.string().optional(),
  letterHeadId: z.string().nullish(),
  letterHead: LetterHeadSchema.nullable(),
  agendaModuleIds: z.string().array(),
  agendaModules: AgendaModuleSchema.array().nullable(),
  parentIds: z.string().array().optional(),
  teamId: z.string().optional(),
  publishedAt: DateTypeSchema.optional(),
});

export const PublicAgendaSchema = AgendaSchema.pick({
  _version: true,
  id: true,
  createdAt: true,
  createdBy: true,
  updatedAt: true,
  updatedBy: true,
  status: true,
  tags: true,
  name: true,
  description: true,
  downloadUrl: true,
  letterHeadId: true,
  letterHead: true,
  agendaModuleIds: true,
  agendaModules: true,
  teamId: true,
  publishedAt: true,
}).extend({
  letterHead: PublicLetterHeadSchema.nullable(),
  agendaModules: PublicAgendaModuleSchema.array().nullable(),
});

// DTOs

export const CreateAgendaDtoSchema = AgendaSchema.partial();

export const PutAgendaDtoSchema = CreateAgendaDtoSchema;

export const PatchAgendaDtoSchema = CreateAgendaDtoSchema;
